import { render, staticRenderFns } from "./InformationTab.vue?vue&type=template&id=291f3bce&"
import script from "./InformationTab.vue?vue&type=script&lang=js&"
export * from "./InformationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports